export default __webpack_public_path__ + "static/cremation-urns-e73e96dd2f684fadeb968b504aaab48d.jpg";